import { useEffect, useState } from 'react';

import { getPromoLotteries } from 'api/client';

export default function useLotteriesTaskPrizeRemainder({
    promoUUID,
    mgmPromoUUID,
    lotteriesTask = [],
    mgmLotteriesTask = [],
    onError = () => {}
}) {
    const [lotteriesRemainder, setLotteriesRemainder] = useState({});

    useEffect(() => {
        if (lotteriesTask.length > 0) {
            getLotteriesRemainder(promoUUID, lotteriesTask)
                .then(r => setLotteriesRemainder(prevState => ({ ...prevState, ...r })))
                .catch(err =>
                    onError({
                        err
                    })
                );
        }
        if (mgmLotteriesTask.length > 0) {
            getLotteriesRemainder(mgmPromoUUID, mgmLotteriesTask)
                .then(r => setLotteriesRemainder(prevState => ({ ...prevState, ...r })))
                .catch(err =>
                    onError({
                        err
                    })
                );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        lotteriesRemainder,
        setLotteryRemainder: ({ uuid, remainder = 0 }) =>
            setLotteriesRemainder(c => ({
                ...c,
                [uuid]: {
                    ...c[uuid],
                    remainder
                }
            })),
        hasInited: Object.keys(lotteriesRemainder).length > 0
    };
}

async function getLotteriesRemainder(promoUUID, lotteryTasks = []) {
    const { payload: lotteries = [] } = await getPromoLotteries(promoUUID);
    return lotteryTasks.reduce((obj, { uuid }) => {
        const data = lotteries.find(l => l.lottery.uuid === uuid);
        if (data) {
            const { prizeRemainder } = data;
            obj[uuid] = {
                remainder: prizeRemainder
            };
        }
        return obj;
    }, {});
}
